import { useCallback, useEffect, useState } from 'react';

import { send } from '@actual-app/core/platform/client/connection';

import { useSyncServerStatus } from './useSyncServerStatus';

/** Whether the sync server has an Open Exchange Rates App ID on file. */
export function useOpenExchangeRatesStatus() {
  const [configured, setConfigured] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const status = useSyncServerStatus();

  const refresh = useCallback(async () => {
    setIsLoading(true);
    const result = await send('exchange-rates-provider-status');
    setConfigured(result?.configured ?? false);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (status === 'online') {
      void refresh();
    } else {
      setConfigured(false);
    }
  }, [status, refresh]);

  return { configured, isLoading, refresh, setConfigured };
}
